import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'

import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  theme: {
    primary: '#0071A7',
    secondary: '#8C6C8F',
    accent: '#F9B450',
    red: '#E50046',
    purple: '#8C6C8F'
  },
  iconfont: 'md'
})
